import { WarningAmberRounded } from "@mui/icons-material";
import { Backdrop, Box, Fab, Fade, Modal, Typography } from "@mui/material";
import { useState } from "react";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 550,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 4
};

export const MyError = ({
  autoShow,
  title,
  desc
}: {
  autoShow?: boolean;
  title: string;
  desc: string;
}) => {
  const [open, setOpen] = useState(autoShow ? true : false);
  return (
    <>
      <Fab
        sx={{
          position: "fixed",
          top: 10,
          right: 10
        }}
        size="small"
        color="error"
        title={title}
        aria-label={title}
        onClick={() => setOpen(true)}
      >
        <WarningAmberRounded color="action" />
      </Fab>
      <Modal
        aria-labelledby="error-modal"
        aria-describedby="error-modal-description"
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500
          }
        }}
      >
        <Fade in={open}>
          <Box sx={{ ...modalStyle, bgcolor: "darkred" }}>
            <Typography
              id="error-modal"
              variant="h6"
              component="h2"
              fontWeight={700}
            >
              {title}
            </Typography>
            <Typography id="error-modal-description" sx={{ mt: 2 }}>
              {desc}
            </Typography>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
